/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_b05841e8',
  dropdown: 'dropdown_b05841e8',
};

export = styles;

loadStyles([{"rawString":".root_b05841e8{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_b05841e8 .dropdown_b05841e8{margin-bottom:0;margin-left:5px}"}]);
/* tslint:enable */